import type { ReactNode } from 'react'

import { EntityTagsProvider } from './EntityTagsProvider'
import { rentalTaggingAdapter } from './rentalTaggingAdapter'
import type { Tag } from './tagging.types'

interface RentalTagsProviderProps {
  children: ReactNode
  refetch: () => Promise<unknown>
  rentalId: string
  rentalTags: Tag[]
}

export const RentalTagsProvider = (props: RentalTagsProviderProps) => {
  const { children, refetch, rentalId, rentalTags } = props

  return (
    <EntityTagsProvider
      adapter={rentalTaggingAdapter}
      entityId={rentalId}
      entityTags={rentalTags}
      refetch={refetch}
    >
      {children}
    </EntityTagsProvider>
  )
}
